import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'home',
      component: function () {
        return import('./views/home.vue')
      }
    },
    {
      path: '/about',
      name: 'about',
      component: function () {
        return import('./views/about.vue')
      }
    },
    {
      path: '/car',
      name: 'car',
      component: function () {
        return import('./views/car.vue')
      }
    },
    {
      path: '/carOwner',
      name: 'carOwner',
      component: function () {
        return import('./views/carOwner.vue')
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: function () {
        return import('./views/contact.vue')
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: function () {
        return import('./views/contact.vue')
      }
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})
